import React, { useState, useEffect, useContext } from 'react'
import { useParams, Redirect } from 'react-router-dom'
import { VirtualMachineService } from '../../services/VirtualMachine'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { VirtualMachineForm } from '../../components/VirtualMachineForm'
import { Layout } from '../../components/Layout'
import { Message } from 'primereact/message'
import './styles.scss'

export const CreateEditVirtualMachine = () => {
  const { id: idToEdit } = useParams()
  const { isAuth: token } = useContext(Context)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [virtualMachineToEdit, setVirtualMachineToEdit] = useState([])
  const [redirectTo, setRedirectTo] = useState(null)

  const config = {
    title: 'Crear recurso',
    icon: GLOBALS.menu.remoteresource.icon,
    link: GLOBALS.menu.remoteresource.link,
    linkList: GLOBALS.menu.remoteresource.linkList,
  }

  if (idToEdit) {
    config.title = 'Editar recurso'
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const [virtualMachine] = await Promise.all([
        (async () => {
          if (idToEdit) {
            return await VirtualMachineService.getById(idToEdit, token)
          }
          return null
        })(),
      ])

      setVirtualMachineToEdit(virtualMachine)
    } catch (e) {
      setError(e.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (data) => {
    try {
      console.log('Iniciando proceso de submit:', data) // Log de los datos iniciales
      setIsLoading(true)

      if (idToEdit) {
        console.log('Actualizando máquina virtual con ID:', idToEdit)
        await VirtualMachineService.update(idToEdit, data, token)
        console.log('Máquina virtual actualizada exitosamente')
      } else {
        console.log('Creando nueva máquina virtual con datos:', data)
        const resultado = await VirtualMachineService.create(data, token)
        console.log('Máquina virtual creada exitosamente:', resultado)
      }

      setIsLoading(false)
      setError(null)
      console.log('Redirigiendo a:', config.linkList)

      setRedirectTo({
        pathname: config.linkList,
        state: { success: true },
      })
    } catch (e) {
      console.error('Error en el proceso:', e)
      console.log('Mensaje de error:', e.message)
      setIsLoading(false)
      setError(e.message)
    }
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }

  return (
    <Layout>
      {isLoading || (!virtualMachineToEdit && idToEdit) ? (
        <div className="loading-container">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
        </div>
      ) : error ? (
        <Message severity="error" text={error}></Message>
      ) : (
        <div className="p-fluid">
          <div className="p-grid">
            <div className="p-col-12">
              <div className="card card-w-title">
                <h1 className="create-edit-title">
                  {config.icon && <i className={config.icon}></i>}
                  {config.title}
                </h1>
                <VirtualMachineForm
                  item={virtualMachineToEdit}
                  isLoading={isLoading}
                  onSubmit={onSubmit}
                  cancelLink={config.linkList}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
